import React from 'react';
import InfoPage, { Section } from '../../components/InfoPage';

const Refund = () => (
  <InfoPage title="Refund policy" lastUpdated="March 1, 2026">
    <p>
      We stand behind every bar. If it isn't working for you, we want to make it right.
    </p>

    <Section heading="60-day guarantee">
      <p>
        Try the Korean Scalp Revival Bar for up to 60 days. If you're not satisfied, contact our team with your order number and we'll
        offer a replacement, exchange, or full refund — your choice.
      </p>
    </Section>

    <Section heading="How to start a return">
      <p>
        1. Email <span className="underline">returns@k-root.example</span> with your order number.<br />
        2. We'll respond within 1–2 business days with instructions.<br />
        3. Ship the item back (we cover the return label on defective products).<br />
        4. Refund issued to original payment method within 5–10 business days of receipt.
      </p>
    </Section>

    <Section heading="Conditions">
      <p>
        — Item should be in original packaging when possible.<br />
        — Bundles must be returned as a complete set.<br />
        — Shipping fees on the original order are non-refundable unless the item was defective.
      </p>
    </Section>

    <Section heading="Damaged or wrong item">
      <p>
        Photograph the issue and email us within 7 days of delivery. We'll send a replacement right away — no need to ship anything back.
      </p>
    </Section>
  </InfoPage>
);

export default Refund;
